import script from "./OnThisDay.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnThisDay.vue?vue&type=script&setup=true&lang=ts"

import "./OnThisDay.vue?vue&type=style&index=0&id=70c4dcbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c4dcbe"]])

export default __exports__